<template lang="pug">
  router-view
</template>

<script>
import '@/assets/css/fonts.css'
import '@/assets/css/main.css'
import '@/assets/css/responsiveMain.css'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Omnes Regular', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f1f1f;
}
body h1, body h2 {
  font-family: 'Omnes Medium';
  color: #1F1F1F;
  font-weight: bold;
}
.swal2-popup #swal2-content {
  font-family: 'Omnes Medium';
}
body h3, body p, body input, body select option, body span, body label {
  font-family: 'Omnes Regular';
  color: #242424;
}
body a {
  font-family: 'Omnes Regular';
  color: #1F1F1F;
}
body select.custom-select {
  background: #fff url(assets/arrow_down.png) no-repeat right 0.75rem center;
}

/* POPUP INFO GENERAL */
.popup-general .popup-general__info {
  width: 365px;
  height: 440px;
  padding: 10px 10px 28px;
  display: flex !important;
  flex-direction: column;
  justify-content: space-evenly;
  row-gap: 15px;
}

.popup-general .swal2-image {
  margin: 20px auto 0;
}

.popup-general .swal2-title {
  color: var(--first-brand-color);
  font-family: 'Omnes Medium';
  font-size: 18px;
  font-weight: normal;
  padding: 0;
}

.popup-general .popup-general__info .swal2-actions {
  margin: 0 0 8px;
}

.popup-general .popup-general__info .swal2-html-container,
.popup-general .popup-general__info #swal2-content {
  color: #535D66;
  font-family: 'Omnes Regular';
  font-size: 18px;
  margin: 0;
  padding: 0 20px;
  line-height: 1.2;
}

.popup-general .popup-general__info .swal2-html-container p,
.popup-general .popup-general__info .swal2-html-container a {
  color: #535D66;
  font-size: 16px;
  line-height: 1.3;
  margin-bottom: 9px;
}

.popup-general .popup-general__info .swal2-html-container p:last-child {
  margin-bottom: 0;
}

.popup-general .swal2-confirm {
  font-family: 'Omnes Semibold';
  background-color: var(--fuchsia-color);
  height: 58px;
  border-radius: 4px;
  width: 100%;
  max-width: 210px;
  font-size: 18px;
  margin: 0 auto 12px;
  user-select: none;
  padding: 0.5em;
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue